/**
 * react-image-gallery v2 marks the visible slide with `image-gallery-center`
 * (not the bare `center` class from v1).
 *
 * @param {Element|null|undefined} slideEl
 * @returns {boolean}
 */
export const isActiveGallerySlide = slideEl =>
  !!slideEl?.classList?.contains('image-gallery-center');
